import { Dialog, Portal } from "@chakra-ui/react";
import { ReactNode, useRef } from "react";

type BaseDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  icon?: ReactNode;
  title?: ReactNode;
  children?: ReactNode;
  footer?: ReactNode;

  bodyPaddingTop?: string | number;
};

export const BaseDialog = ({
  open,
  onOpenChange,
  icon,
  title,
  children,
  footer,
  bodyPaddingTop,
}: BaseDialogProps) => {
  const focusRef = useRef<HTMLDivElement>(null);
  return (
    <Dialog.Root
      initialFocusEl={() => null}
      open={open}
      onOpenChange={(e) => onOpenChange(e.open)}
      placement="center"
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content
            rounded={'none'}
            w="full"
            maxW={{ base: "calc(100% -  32px)", md: "560px" }}
            px={"40px"}
            py={"24px"}
            pt={bodyPaddingTop}
          >
            {(title || icon) && (
                <Dialog.Header
                  p={0}
                  display={"flex"}
                  flexDirection={"column"}
                  alignItems={"start"}
                  gap={"20px"}
                >
                  {icon && <div style={{ width: 64, height: 64 }}>{icon}</div>}
                  {title && (
                    <Dialog.Title textStyle={"bold20"}>{title}</Dialog.Title>
                  )}
                </Dialog.Header>
              )}

            {children && (
              <Dialog.Body
                px={0}
                pt={'24px'}
                pb={0}
                display={"flex"}
                alignItems={"start"}
                flexDirection={"column"}
                gap="24px"
                textStyle={"regular16"}
              >
                {children}
              </Dialog.Body>
            )}

            {footer && (
              <Dialog.Footer px={0} pb={0} pt="26px">
                {footer}
              </Dialog.Footer>
            )}
            <div ref={focusRef}></div>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};
